import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';

import { MgButtonModule } from '@app/src/app/button';

import { DestroyMingaDialogComponent } from './DestroyMingaDialog.component';

@NgModule({
  imports: [
    // Minga dependencies
    MgButtonModule,

    // External dependencies
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    FlexLayoutModule,
  ],
  declarations: [DestroyMingaDialogComponent],

  exports: [DestroyMingaDialogComponent],
})
export class DestroyMingaDialogModule {}
